export const FORMAT_LABEL = { multiple_choice: "Multiple choice", writing: "Written", puzzle: "Puzzle", lab: "Lab" };
export const DIFF_DOT = { easy: "bg-emerald-400", medium: "bg-sky-400", hard: "bg-amber-400" };
export const REFINABLE = ["multiple_choice", "writing", "puzzle", "lab"];
export const correctText = (q) => (typeof q.correct === "number" ? q.options?.[q.correct] : q.correct);
export const cleanOption = (o) => String(o ?? "").replace(/^\s*[A-Fa-f][.)]\s+/, "");
export const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);

export const excerpt = (s, n = 60) => {
  const t = String(s || "").replace(/\s+/g, " ").trim();
  const first = t.split(/(?<=[.?!])\s/)[0];
  const base = first.length > 12 ? first : t;
  return base.length > n ? `${base.slice(0, n - 1).trimEnd()}…` : base;
};

export const countItems = (test) => (test?.sections || []).reduce((a, s) => a + (s.items || []).length, 0);
export const totalMinutes = (test) => (test?.sections || []).reduce((a, s) => a + (Number(s.duration_min) || 0), 0);

// Questions grouped by the competency they assess (rubric order), numbered "group.item".
export function groupByCompetency(test) {
  const rubric = test.rubric || [];
  const groups = new Map(rubric.map((r) => [r.name, { name: r.name, weight: r.weight, items: [] }]));
  (test.sections || []).forEach((s, si) => (s.items || []).forEach((it, ii) => {
    const key = it.assesses || "Other";
    if (!groups.has(key)) groups.set(key, { name: key, weight: null, items: [] });
    const minutes = s.duration_min && s.items?.length ? Math.max(1, Math.round(s.duration_min / s.items.length)) : null;
    groups.get(key).items.push({ ...it, sectionIndex: si, itemIndex: ii, sectionTitle: s.title, minutes });
  }));
  const list = [...groups.values()].filter((g) => g.items.length);
  list.forEach((g, gi) => g.items.forEach((it, k) => { it.number = `${gi + 1}.${k + 1}`; }));
  return list;
}
